<template>
  <section class="container-fluid">
    <CRow class="justify-content-center">
      <CCol sm="8">
        <CCard>
          <CCardHeader>
            <strong>Editar curso ofertado</strong>
          </CCardHeader>
          <CCardBody>
            <ValidationObserver ref="form" v-slot="{ invalid }">
              <form @submit.prevent="edit" v-if="courseOffered.id !== null">
                <section class="row">
                  <!-- Gestión -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="courses_offered_year"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="courses_offered_year"
                          >Gestión</label
                        >
                        <b-form-select
                          v-model="courseOffered.courses_offered_year"
                          :options="coursesOfferedYearsOptions"
                          id="courses_offered_year"
                          size="sm"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Periodo -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="period"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="period"
                          >Periodo</label
                        >
                        <b-form-select
                          v-model="courseOffered.period"
                          :options="periodOptions"
                          value-field="value"
                          text-field="name"
                          id="period"
                          size="sm"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>

                <section class="row">
                  <!-- Pénsum -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="syllabus_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="syllabus_id"
                          >Pénsum</label
                        >
                        <b-form-select
                          v-model="courseOffered.syllabus_id"
                          :options="syllabusOptions"
                          value-field="id"
                          text-field="description"
                          id="syllabus_id"
                          size="sm"
                        >
                          <b-form-select-option :value="null"
                            >--Seleccione un pénsum--</b-form-select-option
                          >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Curso / Pensum -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="course_syllabus_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="course_syllabus_id"
                          >Curso</label
                        >
                        <b-form-select
                          v-model="courseOffered.course_syllabus_id"
                          :options="coursesSyllabusOptions"
                          value-field="id"
                          text-field="course_name"
                          id="course_syllabus_id"
                          size="sm"
                        >
                          <b-form-select-option :value="null"
                            >--Seleccione un curso--</b-form-select-option
                          >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Paralelo -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="parallel"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="parallel"
                          >Paralelo</label
                        >
                        <b-form-select
                          v-model="courseOffered.parallel"
                          :options="parallelOptions"
                          value-field="value"
                          text-field="name"
                          id="parallel"
                          size="sm"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>

                <section class="row">
                  <!-- Tipo de curso -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="type_of_course"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="type_of_course"
                          >Tipo de curso
                        </label>
                        <b-form-select
                          v-model="courseOffered.type_of_course"
                          :options="typeOfCourseOptions"
                          value-field="value"
                          text-field="name"
                          id="type_of_course"
                          size="sm"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Nro. de Aula -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="classroom"
                        rules="required|max:15"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="classroom"
                          >Nro. de Aula</label
                        >
                        <input
                          type="text"
                          v-model="courseOffered.classroom"
                          class="form-control form-control-sm"
                          id="classroom"
                          maxlength="15"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>

                <!-- Tipo de curso REGULAR,SEMI_INTENSIVE,INTENSIVE -->
                <section
                  class="row"
                  v-if="cousersRSI.includes(courseOffered.type_of_course)"
                >
                  <!-- Lunes (Hr. inicio) -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="monday_to_friday_start_time"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label
                          class="control-label"
                          for="monday_to_friday_start_time"
                          >Lunes a viernes (Hr. inicio)</label
                        >
                        <flat-pickr
                          v-model="courseOffered.monday_to_friday_start_time"
                          :config="configHour"
                          class="form-control form-control-sm"
                        ></flat-pickr>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Lunes (Hr. final) -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="monday_to_friday_finish_time"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label
                          class="control-label"
                          for="monday_to_friday_finish_time"
                          >Lunes a viernes (Hr. final)</label
                        >
                        <flat-pickr
                          v-model="courseOffered.monday_to_friday_finish_time"
                          :config="configHour"
                          class="form-control form-control-sm"
                        ></flat-pickr>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>

                <!-- Tipo de curso PROFESSIONAL -->
                <section
                  class="row"
                  v-if="courseOffered.type_of_course == 'PROFESSIONAL'"
                >
                  <!-- Sábado (Hr. inicio) -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="saturday_start_time"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="saturday_start_time"
                          >Sábado (Hr. inicio)</label
                        >
                        <flat-pickr
                          v-model="courseOffered.saturday_start_time"
                          :config="configHour"
                          class="form-control form-control-sm"
                        ></flat-pickr>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Sábado (Hr. final) -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="saturday_finish_time"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="saturday_finish_time"
                          >Sábado (Hr. final)</label
                        >
                        <flat-pickr
                          v-model="courseOffered.saturday_finish_time"
                          :config="configHour"
                          class="form-control form-control-sm"
                        ></flat-pickr>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>

                <!-- Tipo de curso SPECIAL -->
                <template v-if="courseOffered.type_of_course == 'SPECIAL'">
                  <section class="row">
                    <!-- Lunes (Hr. inicio) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="monday_start_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="monday_start_time"
                            >Lunes (Hr. inicio)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.monday_start_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Lunes (Hr. final) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="monday_finish_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="monday_finish_time"
                            >Lunes (Hr. final)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.monday_finish_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Martes (Hr. inicio) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="tuesday_start_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="tuesday_start_time"
                            >Martes (Hr. inicio)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.tuesday_start_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Martes (Hr. final) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="tuesday_finish_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="tuesday_finish_time"
                            >Martes (Hr. final)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.tuesday_finish_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                  </section>
                  <section class="row">
                    <!-- Miercoles (Hr. inicio) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="wednesday_start_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label
                            class="control-label"
                            for="wednesday_start_time"
                            >Miercoles (Hr. inicio)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.wednesday_start_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Miercoles (Hr. final) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="wednesday_finish_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label
                            class="control-label"
                            for="wednesday_finish_time"
                            >Miercoles (Hr. final)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.wednesday_finish_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Jueves (Hr. inicio) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="thursday_start_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="thursday_start_time"
                            >Jueves (Hr. inicio)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.thursday_start_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Jueves (Hr. final) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="thursday_finish_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label
                            class="control-label"
                            for="thursday_finish_time"
                            >Jueves (Hr. final)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.thursday_finish_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                  </section>
                  <section class="row">
                    <!-- Viernes (Hr. inicio) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="friday_start_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="friday_start_time"
                            >Viernes (Hr. inicio)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.friday_start_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Viernes (Hr. final) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="friday_finish_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="friday_finish_time"
                            >Viernes (Hr. final)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.friday_finish_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Sábado (Hr. inicio) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="saturday_start_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="saturday_start_time"
                            >Sábado (Hr. inicio)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.saturday_start_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Sábado (Hr. final) -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="saturday_finish_time"
                          rules="required"
                          v-slot="{ valid, errors }"
                        >
                          <label
                            class="control-label"
                            for="saturday_finish_time"
                            >Sábado (Hr. final)</label
                          >
                          <flat-pickr
                            v-model="courseOffered.saturday_finish_time"
                            :config="configHour"
                            class="form-control form-control-sm"
                          ></flat-pickr>
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                  </section>
                </template>

                <section class="row">
                  <!-- Profesor -->
                  <div class="col" v-if="validationTeacherSelect">
                    <div class="form-group">
                      <label class="control-label" for="teacher_id"
                        >Profesor</label
                      >
                      <v-select
                        label="name"
                        :options="teachersOptions"
                        @search="onSearchTeachers"
                        v-model="courseOffered.teacher_id"
                        :reduce="(teacher) => teacher.id"
                        id="teacher_id"
                        placeholder="Buscar Profesor"
                      >
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching">
                            No hay resultados para <em>{{ search }}</em
                            >.
                          </template>
                          <em v-else>Buscar Profesor</em>
                        </template>
                        <template v-slot:option="option">
                          <span :class="option.icon"></span>
                          {{ `${option.name}` }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ `${option.name}` }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                  </div>
                </section>

                <section class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label for="enabled">Estado</label>
                      <br />
                      <CSwitch
                        :color="color"
                        v-bind="mode"
                        :checked.sync="courseOffered.enabled"
                        id="enabled"
                      />
                    </div>
                  </div>
                </section>

                <router-link
                  to="/cursos-ofertados"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a
                    :href="href"
                    class="card-header-action btn btn-sm btn-danger"
                    @click="navigate"
                  >
                    <CIcon size="sm" name="cil-x-circle" /> Cancelar
                  </a>
                </router-link>
                <button
                  type="submit"
                  class="btn btn-success btn-sm float-right"
                  variant="success"
                  :disabled="invalid || editLoader"
                >
                  <span v-if="!editLoader">
                    <CIcon size="sm" name="cil-save" />
                    Editar
                  </span>
                  <span v-if="editLoader">
                    Cargando
                    <CSpinner color="success" size="sm" />
                  </span>
                </button>
              </form>
            </ValidationObserver>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
import Constants from "@/plugins/constants";
//services
import CoursesOffered from "@/plugins/services/courses-offered";
import CoursesSyllabus from "@/plugins/services/courses-syllabus";
import Teachers from "@/plugins/services/teachers";
import Syllabus from "@/plugins/services/syllabus";

export default {
  name: "CourseOfferedEdit",
  components: { BFormInvalidFeedback, BFormSelect, BFormSelectOption },
  data() {
    return {
      courseOffered: {
        id: null,
        syllabus_id: null,
        teacher_id: null,
        courses_offered_year: new Date().getFullYear(),
        enabled: true,
        type_of_course: null,
        monday_to_friday_start_time: "",
        monday_to_friday_finish_time: "",
      },
      mode: { shape: "pill" },
      color: "primary",
      editLoader: false,
      dataLoader: false,
      teacherLoader: false,
      configDate: {
        dateFormat: "Y",
        showMonths: 1,
        allowInput: true,
      },
      configHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        minuteIncrement:30,
      },
      periodOptions: Constants.periodOptions,
      typeOfCourseOptions: Constants.typeOfCourseOptions,
      parallelOptions: Constants.parallelOptions,
      teachersOptions: [],
      coursesSyllabusOptions: [],
      coursesOfferedYearsOptions: [],
      syllabusOptions: [],
      cousersRSI: ["REGULAR", "SEMI_INTENSIVE", "INTENSIVE"],
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
    validationTeacherSelect() {
      if (this.courseOffered.teacher_id && this.teacherLoader) return true;
      if (this.teachersOptions.length > 0 && this.teacherLoader) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    const { id } = this.$route.params;
    this.getData(id);
    this.getCoursesSyllabus(null);
    this.getCoursesOfferedYears();
    this.getSyllabus();
    this.getTeachers();
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });
  },
  watch: {
    "courseOffered.syllabus_id"(syllabus_id) {
      this.coursesSyllabusOptions = [];
      this.getCoursesSyllabus(syllabus_id);
    },
  },
  methods: {
    getData(id) {
      this.dataLoader = true;
      CoursesOffered.getOne(id)
        .then((res) => {
          this.courseOffered = res.data;
          this.dataLoader = true;
          this.setDataTime();
          if (this.courseOffered.teacher_id)
            this.getTeacherById(this.courseOffered.teacher_id);
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Curso ofertado no encontrado.");
            this.$router.push("/cursos-ofertados");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.$router.push("/cursos-ofertados");
          }
          this.dataLoader = false;
        });
    },
    edit() {
      this.editLoader = true;
      const { id } = this.$route.params;
      this.courseOffered.modified_by = this.userAuth.username;
      this.formatTimeDays();
      CoursesOffered.edit(id, this.courseOffered)
        .then((res) => {
          this.editLoader = false;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.$router.push("/cursos-ofertados");
          } else {
            Utils.setFlash("danger", res.data.message);
            this.$router.push("/cursos-ofertados");
          }
        })
        .catch((err) => {
          this.editLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Curso ofertado no encontrado.");
            this.$router.push("/cursos-ofertados");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al editar(500).");
            this.$router.push("/cursos-ofertados");
          }
        });
    },
    getCoursesSyllabus(syllabus_id) {
      CoursesSyllabus.selectAll(null, syllabus_id)
        .then((res) => {
          this.coursesSyllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearchTeachers(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.getTeachers(loading, search);
      }
    },
    getTeachers(loading = null, search = null) {
      Teachers.selectAll(search)
        .then((res) => {
          this.teachersOptions = res.data;
          this.teacherLoader = true;
          if (loading != null) {
            loading(false);
          }
        })
        .catch((err) => {
          loading(false);
        });
    },
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears(this.userAuth.now);
    },
    getSyllabus() {
      Syllabus.selectAll({ enabled: true })
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTeacherById(teacher_id) {
      Teachers.selectAll(null, teacher_id)
        .then((res) => {
          this.teachersOptions = res.data;
          this.teacherLoader = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatTimeDays() {
      // Tipo de curso REGULAR,SEMI_INTENSIVE,INTENSIVE
      if (this.cousersRSI.includes(this.courseOffered.type_of_course)) {
        this.courseOffered.monday_start_time =
          this.courseOffered.monday_to_friday_start_time;
        this.courseOffered.monday_finish_time =
          this.courseOffered.monday_to_friday_finish_time;

        this.courseOffered.tuesday_start_time =
          this.courseOffered.monday_to_friday_start_time;
        this.courseOffered.tuesday_finish_time =
          this.courseOffered.monday_to_friday_finish_time;

        this.courseOffered.wednesday_start_time =
          this.courseOffered.monday_to_friday_start_time;
        this.courseOffered.wednesday_finish_time =
          this.courseOffered.monday_to_friday_finish_time;

        this.courseOffered.thursday_start_time =
          this.courseOffered.monday_to_friday_start_time;
        this.courseOffered.thursday_finish_time =
          this.courseOffered.monday_to_friday_finish_time;

        this.courseOffered.friday_start_time =
          this.courseOffered.monday_to_friday_start_time;
        this.courseOffered.friday_finish_time =
          this.courseOffered.monday_to_friday_finish_time;

        this.courseOffered.saturday_start_time =
          this.courseOffered.monday_to_friday_start_time;
        this.courseOffered.saturday_finish_time =
          this.courseOffered.monday_to_friday_finish_time;
      }
      // PROFESSIONAL
      if (this.courseOffered.type_of_course == "PROFESSIONAL") {
        this.courseOffered.monday_start_time = "";
        this.courseOffered.monday_finish_time = "";

        this.courseOffered.tuesday_start_time = "";
        this.courseOffered.tuesday_finish_time = "";

        this.courseOffered.wednesday_start_time = "";
        this.courseOffered.wednesday_finish_time = "";

        this.courseOffered.thursday_start_time = "";
        this.courseOffered.thursday_finish_time = "";

        this.courseOffered.friday_start_time = "";
        this.courseOffered.friday_finish_time = "";

        this.courseOffered.saturday_start_time =
          this.courseOffered.saturday_start_time;
        this.courseOffered.saturday_finish_time =
          this.courseOffered.saturday_finish_time;
      }
    },
    setDataTime() {
      // Tipo de curso REGULAR,SEMI_INTENSIVE,INTENSIVE
      if (this.cousersRSI.includes(this.courseOffered.type_of_course)) {
        this.courseOffered.monday_to_friday_start_time =
          this.courseOffered.monday_start_time;
        this.courseOffered.monday_to_friday_finish_time =
          this.courseOffered.monday_finish_time;
      }
      // PROFESSIONAL
      if (this.courseOffered.type_of_course == "PROFESSIONAL") {
        this.courseOffered.monday_to_friday_start_time =
          this.courseOffered.saturday_start_time;
        this.courseOffered.monday_to_friday_finish_time =
          this.courseOffered.saturday_finish_time;
      }
    },
  },
};
</script>
